<template>
    <div>
        <button class="ds-btn mr-1" @click="isModalVisible = true">Importēt</button>

        <b-modal v-model="isModalVisible" @hidden="resetImport" no-close-on-backdrop hide-footer body-class="p-2 mb-3"
                 header-class="bg-light align-items-center" size="xl">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">
                    Importēt darbiniekus
                </h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <div class="text-center mb-3" v-if="currentUser.isAdmin || currentUser.isManager">
                <b-form-checkbox v-model="sendCreateMail" id="sendCreateMail" name="sendMail" switch size="md">
                    Izsutīt epastus
                </b-form-checkbox>
            </div>
            <CsvUpload @uploaded="handleUpload"/>
            <template v-if="users.length">
                <h5 class="text-center mt-4">Darbinieku saraksts</h5>
                <div class="mt-3 border px-3 pb-3" style="overflow-y: scroll; height: 500px;">
                    <div class="row mb-3 py-2 text-center sticky-top bg-white shadow-sm">
                        <div class="col-sm-1 font-weight-bolder">Vārds</div>
                        <div class="col-sm-1 font-weight-bolder">Uzvārds</div>
                        <div class="col-sm-2 font-weight-bolder">Epasts</div>
                        <div class="col-sm-3 font-weight-bolder">Deklarētā dzīvesvietas adrese</div>
                        <div class="col-sm-2 font-weight-bolder">Personas kods</div>
                        <div class="col-sm-1 font-weight-bolder">Amats</div>
                        <div class="col-sm-2 font-weight-bolder">Darbinieku grupa</div>
                    </div>
                    <ValidationObserver ref="observer" @submit.prevent="handleImport" tag="form">
                        <div v-for="(user, i) in users" :key="i" class="row d-flex">
                            <div class="col-sm-1">
                                <ValidationProvider tag="div"
                                                    class="mb-4"
                                                    :vid="`name-${i}`"
                                                    mode="lazy"
                                                    :customMessages="{required: 'Norādi darbinieka vārdu.'}"
                                                    rules="required"
                                                    v-slot="{errors}">
                                    <input type="text" class="w-100 py-1 ds-input" v-model="user.name">
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-1">
                                <ValidationProvider tag="div"
                                                    :vid="`surname-${i}`"
                                                    class="mb-4"
                                                    mode="lazy"
                                                    rules="required"
                                                    :customMessages="{required: 'Norādi darbinieka uzvārdu.'}"
                                                    v-slot="{errors}">
                                    <input type="text" class="w-100 py-1 ds-input" v-model="user.surname">
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-2">
                                <ValidationProvider tag="div"
                                                    :vid="`email-${i}`"
                                                    mode="lazy"
                                                    rules="email"
                                                    :skipIfEmpty="true"
                                                    :customMessages="{email: 'Norādi pareizu e-pastu.'}"
                                                    v-slot="{errors}">
                                    <input type="text" class="w-100 py-1 ds-input" v-model="user.email">
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-3">
                                <ValidationProvider tag="div"
                                                    :vid="`address-${i}`"
                                                    mode="lazy"
                                                    rules="required"
                                                    :customMessages="{email: 'Norādi pareizu adresi.'}"
                                                    v-slot="{errors}">
                                    <input type="text" class="w-100 py-1 ds-input" v-model="user.address">
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-2">
                                <ValidationProvider tag="div"
                                                    :vid="`identityNumber-${i}`"
                                                    mode="lazy"
                                                    rules="required"
                                                    :customMessages="{email: 'Norādi pareizu personas kodu.'}"
                                                    v-slot="{errors}">
                                    <input type="text" class="w-100 py-1 ds-input" v-model="user.identityNumber">
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-1">
                                <ValidationProvider tag="div"
                                                    :vid="`jobTitleId-${i}`"
                                                    class="mb-4"
                                                    mode="lazy"
                                                    rules="required"
                                                    :customMessages="{required: 'Norādi darbinieka amatu.'}"
                                                    v-slot="{errors}">
                                    <b-form-select id="jobTitleId" class="w-100 py-1 ds-input" v-model="user.jobTitleId" :options="jobTitleOptions"/>
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-2">
                                <ValidationProvider tag="div"
                                                    :vid="`userGroup-${i}`"
                                                    class="mb-4"
                                                    mode="lazy"
                                                    rules="required"
                                                    :customMessages="{required: 'Norādi darbinieka grupu.'}"
                                                    v-slot="{errors}">
                                    <b-form-select id="userGroup" class="w-100 py-1 ds-input" v-model="user.userGroup" :options="usersGroupsOptions"/>
                                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>

                <div class="text-center">
                    <button @click="handleImport" class="ds-btn ds-btn--success mt-3" :disabled="isActiveRequest"
                            :class="{'ds-btn--disabled': isActiveRequest}">
                        Importēt ( {{ users.length }} )
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapMutations, mapGetters} from 'vuex';
    import slugify from 'slugify';
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {email, required} from 'vee-validate/dist/rules';

    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import CsvUpload from '@/components/global/CsvUpload';
    import {generatePassword} from '../../utils/password-generator';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'users-import',
        components: {CsvUpload, ValidationObserver, ValidationProvider},
        data: () => ({
            isModalVisible: false,
            sendCreateMail: false,
            users: [],
        }),
        created() {
            extend('required', required);
            extend('email', email);
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                importUsers: userStoreTypes.ACTION_IMPORT_USERS,
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
            }),
            async handleUpload(data) {
                // 1. gets back users ( invalid / valid data )
                this.users = data.users;

                // 2. generate password, generate username
                this.users = this.users.map((user, index) => {
                    user.password = generatePassword();
                    user.username = slugify(`${user.name[0]}${user.surname[0]}${user.identityNumber}`);
                    user.index = index;

                    const jobTitleData = this.jobTitleOptions.find(({textValue}) => textValue === user.jobTitle);

                    user.jobTitleId = jobTitleData ? jobTitleData.value : null;
                    user.jobTitle = '';
                    
                    const userGroupData = this.usersGroupsOptions.find(({text}) => text === user.userGroup);

                    user.userGroup = userGroupData ? userGroupData.value : null;
                    
                    return user;
                });

                // 3. wait for form to load, there are fkloads of elements in case of many imports
                // so it takes time for the browser ...
                const int = setInterval(async () => {
                    if (!this.$refs.observer) {
                        return;
                    }

                    await this.$refs.observer.validate();

                    clearInterval(int);
                }, 500);
            },
            resetImport() {
                this.users = [];
            },
            async handleImport() {
                // 2. generate password, generate username
                this.users = this.users.map((user) => {
                    const randId = Math.random().toString(36).substr(2, 6);
                    user.username = slugify(`${user.name}${user.surname[0]}_${randId}`);
                
                    return user;
                });

                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    await this.importUsers({companyId: this.$route.params.companyId || this.currentUser.company._id, users: this.users, sendCreateMail: this.sendCreateMail});
                    this.isModalVisible = false;
                    const users = await this.getUsers({companyId: this.$route.params.companyId || this.currentUser.company._id});
                    this.setCurrentCompanyUsers(users);
                    this.setAlertData({type: 'primary', message: 'Darbinieki importēti!'});
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            }
        },
        computed: {
            ...mapGetters('user', {
                /** @type {function|*} */
                isActiveRequest: userStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            ...mapGetters('company', {
                /** @type {boolean|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            jobTitleOptions() {
                return this.currentCompany.jobTitles.reduce((jobTitles, {_id, name, subName}) => {
                    
                    const formatedSubName = subName ? `(${subName})` : '';

                    jobTitles.push({value: _id, text: `${name} ${formatedSubName}`, textValue: name});

                    return jobTitles;
                }, [{value: null, text: 'Nav amatu identifikatoru'}]);
            },
            usersGroupsOptions() {
                return this.currentCompany.usersGroups.reduce((groups, {_id, name}) => {

                    groups.push({value: _id, text: name});

                    return groups;
                }, [{value: null, text: 'Nav grupas'}]);
            },
        }
    }
</script>